import React from "react"
import Grid from "@mui/material/Grid"
import { makeStyles } from "@mui/styles"
import Text from "@mui/material/typography"
import { StaticImage } from "gatsby-plugin-image"
import CopyrightIcon from "@mui/icons-material/Copyright"
import useMediaQuery from "@mui/material/useMediaQuery"
import { useTheme } from "@mui/material"
import { Link } from "gatsby"
import { Container } from "@material-ui/core"
import PlayStore from "../../images/PLA.png"
import AppStore from "../../images/aPP.png" 
import "./footer.css"
import dr from "../../images/dr.png"


const useStyles = makeStyles({})

const Footer = () => {
  const classes = useStyles()
  const theme = useTheme()
  const smDown = useMediaQuery(theme.breakpoints.down("sm"))
  const mdDown = useMediaQuery(theme.breakpoints.down("md"))
  const [expanded, setExpanded] = React.useState(false)

  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }
  return (
    <footer>
      <div style={{ padding: "100px 0", position: "relative" }}>
        <Container maxWidth={"lg"}>
          <Grid container>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <Text
                style={{
                  fontFamily: "Montserrat",
                  fontSize: smDown ? "30px" : "50px",
                  fontWeight: "bold",
               //   paddingLeft: smDown ? "6px" : "unset",
                }}
              >
                Stay Healthy With Us!
              </Text>
              <div style={{ height: "12px" }} />
              <Text regular variant={"h6"} style={{ maxWidth: "400px" }}>
                Download the Doctors for Syria App from Play and App store!
              </Text>
              <div style={{ height: "32px" }} />
              <div style={{ display: "flex" }}>
                <a href={"https://play.google.com/store/apps/details?id=ai.unicode.dfs"}>
                                <img src={PlayStore} alt={""} style={{width:"90%"}} />
                            </a>
                <div style={{ width: "18px" }} />
                <a href={"https://apps.apple.com/jo/app/doctors-for-syria/id1560574894"}>
                                <img src={AppStore} alt={""}  style={{width:"90%"}} />
                            </a>
              </div>
            </Grid>
            {!smDown && (
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <img alt={"Download the Sydetasker App"} src={dr} style={{ height: "85%", position: "absolute", bottom: "-26px" }} />
                </div>
              </Grid>
            )}
          </Grid>
        </Container>
      </div>
      <div style={{ width: "100%", padding: "32px 0", background: "#120730" }}>
            <Container maxWidth={'lg'}>
                <Grid container spacing={4}>
                    <Grid item lg={3} xl={3} sm={12} xs={12}>
                        <Link to='/'>
                            <div style={{ display: "flex", alignItems: "center", margin: "0 auto" }}>
                                <Text variant={"h6"} style={{ transform: "translateY(-1px)" }} black>
                                    <Link variant={"primary"} to={"/"} style={{ color: "white" }}>
                                      Doctors for Syria
                                    </Link>
                                </Text>
                            </div>
                        </Link>
                        <div style={{ height: "18px" }} />
                        <Text variant={"body1"} style={{ color: "white", opacity: "0.8", height: "85%" }} regular>Stay healthy with us !</Text>
                    </Grid>
                    <Grid item lg={2} xl={2}>
                    <div class="button_cont" align="center">
                        <Text variant={"overline"} medium style={{ color: "white", marginBottom: "6px",paddingRight:"10px" }}>Company</Text>
                     
                        <Text variant={"caption"} component={"p"} regular style={{ lineHeight: "2.0", paddingRight:"30px" }} className="example_f"><Link outside to={"/"} style={{ color: "white" }} variant={"secondary"}>Home <span></span></Link></Text>

                        <Text variant={"caption"} component={"p"} regular style={{ lineHeight: "2.0" , paddingRight:"8px"}} className="example_f"><Link outside to={"/mission"} style={{ color: "white" }} variant={"secondary"}> Missions <span></span></Link></Text>
                     
                        <Text variant={"caption"} component={"p"} regular style={{ lineHeight: "2.0", paddingRight:"15px" }} className="example_f"><Link outside to={"https://play.google.com/store/apps/details?id=ai.unicode.dfs"} style={{ color: "white" }} variant={"secondary"}><span></span></Link></Text>
                  </div>  </Grid>
                 
                    <Grid item lg={2} xl={2}>
                    <div class="button_cont" align="center">
                        <Text variant={"overline"} medium style={{ color: "white", marginBottom: "6px" ,  }}>contact Us</Text>
                   
                        <Text variant={"caption"} component={"p"} regular style={{ lineHeight: "2.0" , paddingRight:"5px"}} className="example_f"><Link to={"/doctors-contactus"} style={{ color: "white" }} variant={"secondary"}> As a Doctor <span></span> </Link> </Text>
                       
                        <Text variant={"caption"} component={"p"} regular style={{ lineHeight: "2.0" }} className="example_f" ><Link to={"/contactUs"} style={{ color: "white" }} variant={"secondary"}  > As a Patiant <span></span></Link> </Text></div>
            
                    </Grid>
                    <Grid item lg={2} xl={2}>
                    <div class="button_cont" align="center">
                        <Text variant={"overline"} medium style={{ color: "white", marginBottom: "6px", paddingRight:"50px" }}>Legal</Text>
                      
                        <Text variant={"caption"} component={"p"} regular style={{ color: "white", lineHeight: "2.0" }} className="example_f"><Link to={"/privacy"} style={{ color: "white" }} variant={"secondary"}>Privacy Policy <span></span></Link> </Text>
                        <Text variant={"caption"} component={"p"} regular style={{ color: "white", lineHeight: "2.0" }} className="example_f"><Link to={"/terms"} style={{ color: "white" }} variant={"secondary"}>Terms of Use <span></span></Link> </Text>
                  </div>
                    </Grid>
                
                </Grid>
                <div style={{ margin: "24px 0", background: "rgb(70,70,80)", height: "1px" }} />
                <Grid container spacing={4} justify={"space-between"} alignItems={"center"}>
                    <Grid item xs={12} sm={12} md={4} lg={12} xl={12}>
                        <div style={{ display: "flex", alignItems: "center", margin: "0 auto" , justifyContent:"center", textAlign:"center" }}>
                            {/* <img src={SydeLogo} alt={"Sydetasker Logo"} style={{ filter: "invert(1) grayscale(1) brightness(1.5)", marginRight: "16px", opacity: "0.7" }} height={22} /> */}
                            <Text variant={"body2"} style={{ color: "white", opacity: "0.5" }} medium>
                                © {new Date().getFullYear()} 2022 Doctors for Syria. All Rights Reserved.  
          

                            </Text>
                        </div>
                    </Grid>
            
                       
                </Grid>
            </Container>
        </div>
    </footer>
  )
}

export default Footer
